/* esm.sh - react-dom@19.3.0 */
export * from "/*react-dom@19.3.0/esnext/react-dom.mjs";
export { default } from "/*react-dom@19.3.0/esnext/react-dom.mjs";
